import { jsx as _jsx } from "react/jsx-runtime";
import { createContext } from "react";
import { FluentProvider, webDarkTheme } from "@fluentui/react-components";
export const ToolContext = createContext({ useFluent: false, disableCopy: false, toolName: "", size: undefined });
/**
 * For tools which are ready to move over the fluent, wrap the root of the tool (or the panel which you want fluentized) with this component
 * Today we will only enable fluent if the URL has the `newUX` query parameter is truthy
 * @param props
 * @returns
 */
export const FluentToolWrapper = (props) => {
    const url = new URL(window.location.href);
    const useFluentFromUrl = url.searchParams.has("newUX") || url.hash.includes("newUX");
    const useFluent = props.useFluent ?? useFluentFromUrl;
    const contextValue = {
        useFluent,
        disableCopy: !!props.disableCopy,
        toolName: props.toolName,
        size: props.size,
    };
    return useFluent ? (_jsx(FluentProvider, { theme: props.customTheme || webDarkTheme, children: _jsx(ToolContext.Provider, { value: contextValue, children: props.children }) })) : (_jsx(ToolContext.Provider, { value: contextValue, children: props.children }));
};
//# sourceMappingURL=fluentToolWrapper.js.map